export const enum MediaKind {
    IMAGE = 'image',
    VIDEO = 'video',
}
